
import { TechnicusFeedJobDto } from "../api/technicus/types";

import type { DrawerSize } from "@/components/ui/v2/use-drawer";
import { createVacancyDrawerRowClickHandler } from "@/features/integrations/shared/utils/vacancyDrawerRowClick";

type RowClickOptions = {
  drawerTitle?: string;
  onError?: () => void;
};

/**
 * Creates a row click handler for Technicus jobs that opens a vacancy drawer.
 * Delegates to the generic vacancy drawer handler with Technicus-specific ID extraction.
 */
export function createTechnicusRowClickHandler(
  clientId: string | undefined,
  openDrawer: (content: React.ReactNode, title: string, size?: DrawerSize) => void,
  options?: RowClickOptions
): (row: unknown) => Promise<void> {
  if (!clientId) {
    return async () => {};
  }

  return createVacancyDrawerRowClickHandler(clientId, openDrawer, {
    getRowId: (row) => (row as TechnicusFeedJobDto).id,
    drawerTitle: options?.drawerTitle,
    onError: options?.onError,
  });
}
